import React, { useContext } from "react";
import ShareButton from "../ShareButton.jsx";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CopiedContext from "../../../CopiedContext";

const LinkButton = ({ mediaShareURL, shareText, mediaType, gameData, sectionName, showLabel }) => {
  const { showCopied, setShowCopied } = useContext(CopiedContext);

  let utm = "";
  if (sectionName === "Action Replay") {
    utm = "utm_source=Stories&utm_medium=link_share&utm_campaign=action_replay";
  }

  const getIconSource = (sectionName) => {
    if (sectionName === "Full Story") {
      return "./img/shareStoryLink.svg"; // Icon for sharing full story
    }
    return "./img/share_icon_circle_link.svg"; // Default white icon for others
  };

  const separator = mediaShareURL.includes("?") ? "&" : "?";
  const fullUrl = mediaShareURL + (utm ? separator + utm : "");
  const iconSource = getIconSource(sectionName);

  return (
    <CopyToClipboard text={fullUrl} onCopy={() => setShowCopied(true)}>
      <ShareButton
        onClick={function () {
          return true;
        }}
        source={iconSource}
        btnName="Link"
        mediaType={mediaType}
        gameData={gameData}
        sectionName={sectionName}
        btnLabel={showLabel ? "Copy Link" : ""}
      />
    </CopyToClipboard>
  );
};

export default LinkButton;
